import { VStack } from '@chakra-ui/react';
import { Form, Formik, Field } from 'formik';
import { useSearchParams } from 'react-router-dom';

import { useChangePassword } from '@/v5/@hooks/auth/useChangePassword';
import { changePasswordValidationSchema } from '@/v5/validation/authValidation';

import { PasswordValidationField } from '@/v5/components/molecules/FormField/PasswordValidationField';
import { SubmitButton } from '@/v5/components/atoms/Button/SubmitButton';
import { TcapHeading } from '@/v5/components/atoms/Heading/TcapHeading';
import { TcapLink } from '@/v5/components/atoms/Link/TcapLink';

function ChangePasswordForm() {
    const [searchParams] = useSearchParams();
    const { handleSubmit, isLoading, resetMessages } = useChangePassword();

    const token = searchParams.get('token');
    const username = searchParams.get('username');

    const initialValues = {
        password: '',
        token,
        username,
    };

    return (
        <VStack spacing={4} align="stretch" px="1px">
            <VStack spacing={2} textAlign="center">
                <TcapHeading>Change your password</TcapHeading>
            </VStack>

            <Formik
                initialValues={initialValues}
                validationSchema={changePasswordValidationSchema}
                onSubmit={handleSubmit}>
                {({ isSubmitting, values, errors }) => (
                    <Form>
                        <VStack spacing={4}>
                            <Field
                                name="password"
                                onFocus={resetMessages}
                                component={PasswordValidationField}
                                label="New Password"
                                isOpen={Boolean(
                                    values?.password && errors?.password,
                                )}
                            />

                            <SubmitButton
                                isLoading={isLoading || isSubmitting}
                                loadingText="Changing password..."
                                width="full"
                                className="max-h-10">
                                Change my password
                            </SubmitButton>

                            <TcapLink
                                to="/"
                                state={{ from: '/change-password' }}>
                                Back to login
                            </TcapLink>
                        </VStack>
                    </Form>
                )}
            </Formik>
        </VStack>
    );
}

export { ChangePasswordForm };
